export default __webpack_public_path__ + "leaf.svg?79dc486ec86a4a70f98082f280ec7c83";